import { Input, DatePicker, Select, RadioGroup, Radio, CheckboxGroup, Checkbox, Option } from "element-ui";
import { isEmpty } from "@/utils/shared";
export default {
  name: "SearchBar",
  components: {
    Input: Input,
    DatePicker: DatePicker,
    Select: Select,
    RadioGroup: RadioGroup,
    Radio: Radio,
    CheckboxGroup: CheckboxGroup,
    Checkbox: Checkbox,
    Option: Option
  },
  props: {
    title: String,
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    renderList: Array
  },
  data: function data() {
    return {
      showSearch: false,
      demoList: [{
        type: "input",
        tip: "患者登记号",
        key: "num",
        props: {
          placeholder: "请输入患者姓名和登记号"
        }
      }, {
        type: "input",
        tip: "患者登记号",
        key: "tel",
        props: {
          placeholder: "请输入操作员登录名"
        }
      }, {
        type: "select",
        tip: "签约状态",
        key: "state",
        props: {
          placeholder: "请选择"
        }
      }, {
        type: "date",
        tip: "签约时间",
        key: "time",
        props: {
          placeholder: "请选择"
        }
      }, {
        type: "date",
        tip: "到期时间",
        key: "dueTime",
        props: {
          placeholder: "请选择"
        }
      }]
    };
  },
  computed: {
    hasSearchParams: function hasSearchParams() {
      return !isEmpty(this.renderList);
    }
  }
};